var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3692 24.7136L44.1192 34.4211L47.5467 48.9386C47.7358 49.7267 47.6871 50.5531 47.4068 51.3135C47.1264 52.074 46.627 52.7342 45.9716 53.211C45.3161 53.6877 44.5341 53.9594 43.7243 53.992C42.9145 54.0245 42.1132 53.8162 41.4217 53.3936L28.7967 45.6236L16.1642 53.3936C15.4728 53.8138 14.6725 54.02 13.8641 53.9863C13.0557 53.9526 12.2753 53.6805 11.6212 53.2042C10.9672 52.7279 10.4687 52.0687 10.1885 51.3096C9.9083 50.5506 9.85898 49.7256 10.0467 48.9386L13.4867 34.4211L2.23672 24.7136C1.62496 24.1848 1.18253 23.4876 0.964675 22.7089C0.746819 21.9303 0.763195 21.1047 1.01176 20.3352C1.26032 19.5658 1.73005 18.8867 2.36229 18.3826C2.99453 17.8786 3.76126 17.572 4.56672 17.5011L19.3167 16.3111L25.0067 2.54106C25.3147 1.7906 25.8389 1.14868 26.5126 0.696904C27.1864 0.245128 27.9793 0.00390625 28.7905 0.00390625C29.6017 0.00390625 30.3945 0.245128 31.0683 0.696904C31.742 1.14868 32.2662 1.7906 32.5742 2.54106L38.2617 16.3111L53.0117 17.5011C53.8188 17.5693 54.5877 17.8742 55.2223 18.3776C55.8568 18.8809 56.3287 19.5603 56.5788 20.3307C56.8289 21.1011 56.8461 21.9281 56.6283 22.7082C56.4105 23.4883 55.9673 24.1867 55.3542 24.7161L55.3692 24.7136Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.1416a7b3d1aed21d6f39b180f49e98b3.svg";
export { ForwardRef as ReactComponent };